import React from 'react';
import { useState } from 'react';
 

const EssenceProduct = ({image, alt, price, checkName, name}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  }

  return (
    <div class="border  product-card pt-3 h-100" onClick={handleClick}>
      <div class="d-flex flex-column">
        <div class="image px-3 pb-3 flex-grow-1">
          <img src={image} alt={alt} class="img-fluid h-100" />
        </div>
        <div class="description px-3  flex-grow-1 d-flex flex-column justify-content-between">
          <p class="product-name mb-3">{name}</p>
          <div class="d-flex justify-content-between align-items-center">
            <p class="product-info mb-0">{price} € / m2</p>
            <div class="checkbox-container">
              <input type="checkbox" name={checkName} className="custom-checkbox" checked={isChecked} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EssenceProduct